const backendData = `
<p>
    <h3>1. Umumiy qoidalar</h3>
    <p>1.1. Doncoin – bu o‘zbek dasturchilari tomonidan ishlab chiqilgan interaktiv mukofot tokeni bo‘lib, foydalanuvchilarga xizmatlardan foydalanganlik va faollik uchun taqdim etiladi. 1.2. Tokenning berilish tartibi va miqdori platforma siyosatiga muvofiq belgilanadi va istalgan vaqtda o‘zgarishi mumkin. 1.3. Doncoin real pul yoki boshqa aktivlarga kafolatlangan ekvivalentga ega emas va platforma doirasida ishlatilishi mumkin..</p>
    <h3>2. Foydalanish va almashtirish</h3>
    <p>2.1. <b>Doncoin</b> foydalanuvchilarga platformadagi maxsus xizmatlar, chegirmalar yoki bonuslardan foydalanish imkonini beradi. 2.2. Tokenlarni boshqa foydalanuvchilarga uzatish yoki savdo qilish faqat rasmiy ekotizim doirasida ruxsat etiladi. 2.3. Platforma ma’muriyati Doncoinni istalgan vaqtda bekor qilish, muddatini tugatish yoki yangi foydalanish shartlarini joriy etish huquqiga ega.</p>
    <h3>3. <i>Cheklovlar</i> va xavfsizlik</h3>
    <blockquote>3.1. Doncoin firibgarlik, noqonuniy yo‘llar bilan ishlab topish yoki platformaning noto‘g‘ri ishlatilishi aniqlansa, avtomatik ravishda bloklanishi yoki bekor qilinishi mumkin. 3.2. Foydalanuvchilar Doncoin balanslari va tranzaksiyalarini xavfsiz saqlash uchun o‘z akkauntlari xavfsizligini ta’minlashlari shart. 3.3. Platforma Doncoin yo‘qolishi yoki noqonuniy harakatlar natijasida yo‘qotilgan tokenlar uchun javobgar emas.</blockquote>
    <h3>4. Muddat va amaliyot</h3>
    <p>4.1. Doncoinning amal qilish muddati platforma tomonidan belgilanadi va tokenning yaroqlilik muddati tugaganda avtomatik ravishda bekor bo‘lishi mumkin. 4.2. Platforma Doncoin tizimini takomillashtirish yoki uning shartlarini o‘zgartirish huquqini o‘zida saqlab qoladi. 4.3. Foydalanuvchilar Doncoin bilan bog‘liq barcha yangilanish va qoidalarni kuzatib borishlari lozim.</p>
    <a href="https://google.com">
     google.com
    </a>
    <ol>
        <li>123123</li>
        <li>123123</li>
        <li>123123</li>
        <li>123123</li>
        <li>123123</li>
    </ol> 
    <ul>
        <li>123123</li>
        <li>123123</li>
        <li>123123</li>
        <li>123123</li>
        <li>123123</li>
    </ul>
</p>
`;

const StaticPage = () => {
    return (
        <div className="container">
            <div className="static-text" dangerouslySetInnerHTML={{__html: backendData}}/>
            <style jsx>{`
                .static-text p {
                    color: white;
                    margin-bottom: 1rem;
                }

                .static-text ol {
                    list-style-type: decimal;
                    padding-left: 1.25rem;
                    color: white;
                }

                .static-text ul {
                    list-style-type: disc;
                    padding-left: 1.25rem;
                    color: white;
                }

                .static-text a {
                    color: #2585FF;
                    text-decoration: underline;
                }

                .static-text h1 {
                    font-size: 1.875rem;
                    font-weight: bold;
                    color: white;
                    margin-bottom: 1rem;
                }

                .static-text h2 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    margin-bottom: 0.75rem;
                }

                .static-text h3 {
                    font-size: 1.25rem;
                    font-weight: 500;
                    color: white;
                    margin-bottom: 0.5rem;
                }

                .static-text b {
                    font-weight: bold;
                }

                .static-text i {
                    font-style: italic;
                }

                .static-text blockquote {
                    border-left: 4px solid rgba(255, 255, 255, 0.08);
                    padding: 0.5rem 0.5rem 0.5rem 1rem;
                    font-style: italic;
                    color: #fff;
                    background-color: rgba(255, 255, 255, 0.08);
                    margin-bottom: 0.5rem;
                }
            `}</style>
        </div>
    );
};

export default StaticPage;
